module.exports = __webpack_public_path__ + "themes/mf/img/character@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/character@2x.png
// module id = 72
// module chunks = 3